// extracted by mini-css-extract-plugin
export default {"copyButton":"CopyButton_copyButton__NczY+","copyButtonIcon":"CopyButton_copyButtonIcon__4-Nuv"};